export default {
  "content": "<g clip-path=\"url(#clip0_30_1014)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#7B61FF\"><path d=\"M8.374 13a1 1 0 01.95.69l1.627 5A1.002 1.002 0 0110 20H1a1.001 1.001 0 01-.951-1.31l1.626-5a1 1 0 01.95-.69h5.749zm-5.997 5h6.246l-.976-3H3.352l-.975 3zM21.374 13a1 1 0 01.95.69l1.627 5A1.002 1.002 0 0123 20h-9a1.001 1.001 0 01-.951-1.31l1.626-5a1 1 0 01.95-.69h5.749zm-5.022 2l-.975 3h6.246l-.976-3h-4.295zM14.874 4a1 1 0 01.95.69l1.627 5A1.001 1.001 0 0116.5 11h-9a1.001 1.001 0 01-.951-1.31l1.626-5a1 1 0 01.95-.69h5.749zM8.877 9h6.246l-.976-3H9.852l-.975 3z\"/></g><defs><clipPath id=\"clip0_30_1014\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};